import formatDate       from "@/client/helpers/formatDate";
import { DEVICE_TYPES } from "../client/constants";
import roundTo          from "./roundTo";
import dateParse        from 'date-fns/parse';
import dateFormat       from 'date-fns/format';

const deviceTypesWithRound = [
  DEVICE_TYPES['отопление'],
  DEVICE_TYPES['отопление (распределитель)'],
  DEVICE_TYPES['отопление (шифрованный)'],
];

const getPrevValue = ( device, value ) => {
  const currentMonthDate = dateParse(value.month, 'yyyy-MM', new Date());
  const prevMonthDate = new Date(currentMonthDate);
  prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);
  const prevMonth = dateFormat(prevMonthDate, 'yyyy-MM');
  return device.values.find(v => v.month === prevMonth);
};

const isColdWaterBigDifference = ( device, value, prevValue ) => {
  return device.type === DEVICE_TYPES['холодная вода'] && value.value - 30 >= prevValue.value;
};

const isHotWaterBigDifference = ( device, value, prevValue ) => {
  return device.type === DEVICE_TYPES['горячая вода'] && value.value - 20 >= prevValue.value;
};

const getText = ( device, value, showConsumption, prevValue ) => {
  if (showConsumption) return value.consumption === null ? '-' : value.consumption;
  if (!value) return '-';
  if (value.value === null) return '-';

  let text = value.value;
  if (!deviceTypesWithRound.includes(device.type)) text = roundTo(+value.value, 2);
  if (value.is_standard) text += ' (н)';
  else if (value.calculated) text += ' (ср)';
  return text;
};

const getTitle = ( device, value, showConsumption, prevValue ) => {
  let text = '';
  if (showConsumption) return text;
  if (!value) return text;

  if (value.value !== null) {
    if (value.is_standard) text += 'Норматив; ';
    else if (value.calculated) text += 'Среднее значение; ';
    else if (prevValue && !prevValue.is_standard && !prevValue.calculated) {
      if (prevValue.value > value.value) text += 'Показание меньше предыдущего ';
      if (isHotWaterBigDifference(device, value, prevValue)) text += 'Показание больше чем на 20 кубов; ';
      if (isColdWaterBigDifference(device, value, prevValue)) text += 'Показание больше чем на 30 кубов; ';
    }
  }

  if (value.created_at && value.created_at.date) text += `Создано - ${formatDate(value.created_at.date, 'dd.MM.yyyy HH:mm:ss')}; `;
  if (value.user && value.user.name) text += `Пользователь - ${value.user.name}; `;

  return text.trim();
};

const getStyle = ( device, value, showConsumption, prevValue ) => {
  if (showConsumption) return '';
  if (value.value === null) return '';

  let bgColor = null;
  if (value.is_standard) bgColor = 'rgb(246, 193, 81)';
  else if (value.calculated) bgColor = 'rgb(var(--app-info))';
  else if (
    prevValue &&
    !prevValue.is_standard &&
    !prevValue.calculated &&
    (
      isHotWaterBigDifference(device, value, prevValue) ||
      isColdWaterBigDifference(device, value, prevValue) ||
      prevValue.value > value.value
    )
  ) {
    bgColor = 'rgb(255, 245, 173, .6);';
  }

  if (!bgColor) return '';
  return `background: ${bgColor};`;
};

export const renderDeviceValue = ( device, value, showConsumption ) => {
  if (!value) return '-';
  if (showConsumption) return value.consumption === null ? '-' : value.consumption;
  if (value.value === null) return '-';
  // if (!deviceTypesWithRound.includes(device.type)) return roundTo(+value.value, 2).toString().replace('.', ',');
  return value.value.toString().replace('.', ',');
};

export const renderDeviceCell = ( device, value, showConsumption ) => {
  const prevValue = getPrevValue(device, value);
  const style = getStyle(device, value, showConsumption, prevValue) + ' position: absolute; top: -1px; left: 0;  width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;';
  const title = getTitle(device, value, showConsumption, prevValue);
  const text = getText(device, value, showConsumption, prevValue);
  return `<span style="${style} " title="${title}">${text}</span>`;
};


// unit_id - используется?
// let unit = null;
// if (value.unit_id) {
//   unit = this.units.find(unit => unit.id === value.unit_id);
// }

// if (unit) {
//   text += " " + unit.name;
// }
//
